var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-timeline-item',{attrs:{"small":"","fill-dot":""}},[_c('v-row',{staticClass:"margin-l-n1 margin-t-n4"},[_c('v-col',{staticClass:"font-20",attrs:{"sm":"12","md":"6"}},[_c('h2',[_vm._v(_vm._s(_vm.event.date))]),_vm._v(" "+_vm._s(_vm.event.text)+" ")]),_c('v-col',{attrs:{"sm":"12","md":"6"}},[_c('img',{class:{
          'h-auto max-h-400': _vm.$vuetify.breakpoint.smAndUp,
          'max-w-300': _vm.$vuetify.breakpoint.xs,
        },attrs:{"src":_vm.image}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }